import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";

import {
  Button,
  Divider,
  DoubleButton,
  Label,
  SreenCoverLoading,
  usePopupPage,
} from "src/components";
import { recoilStates } from "src/recoil/recoilStates";
import styled from "styled-components";
// import { EventTeamDataType, TeamType } from "src/types";

import { dateFormat } from "src/utils";
import { useNavigate } from "react-router-dom";
import { createTeeshotAxiosInstance } from "src/http";
import { TeamSubmitDataType } from "src/types";
import { useAlert, useConfirm, useRefetchEventBookings } from "src/hooks";
import { usePopupSelectV2 } from "src/components/PopupSelect";
import MemberSearchPopupContentsEvent from "../components/PopupPageContents/MemberSearchPopupContentsEvent";

// export default function EventBookingTeamRegister() {
//   return <>월단체 팀등록페이지</>;
// }

export default function EventBookingTeamRegister() {
  const navigate = useNavigate();

  const [bookingApplication, setBookingApplication] = useRecoilState(recoilStates.eventApplication);
  const clubRelData = bookingApplication?.event_booking_rel_club?.find((cr) => cr.status_id === 5);
  const rounds = clubRelData?.roundDates;

  const {
    PopupSelect: DatePopupSelect,
    activeIds: activeDateIds,
    propsToInject,
  } = usePopupSelectV2({
    defaultSelectIds: [
      rounds
        ?.filter((r) => {
          return new Date(new Date(r.round_date || "").getTime() + 86400 * 1000) > new Date();
        })
        ?.reduce(
          (acc: any, curr: any) => {
            if (new Date(curr?.round_date || "") < new Date(acc?.round_date || "")) {
              return curr;
            }
            return acc;
          },
          { round_date: new Date(19999999999999) }
        )?.id || 0,
    ],
  });

  const [teams, setTeams] = useState<TeamSubmitDataType>();
  const [maxTeams, setMaxTeams] = useState(20);

  const [forcedRerenderFlag, setForcedRerenderFlag] = useState(true);

  const currentRound = rounds?.find((r) => r.id === activeDateIds?.[0]);
  const hasSavedData = Boolean(currentRound?.is_temp_saved) || Boolean(currentRound?.is_fixed);

  useEffect(() => {
    setForcedRerenderFlag(false);
    setTimeout(() => {
      setForcedRerenderFlag(true);
    }, 0);
  }, [activeDateIds]);
  useEffect(() => {
    const roundData = rounds?.find((r) => r.id === activeDateIds?.[0]);
    if (!roundData?.teams || roundData?.teams?.length < 1) {
      const initialTeams = [];
      for (let i = 1; i <= maxTeams; i++) {
        initialTeams.push({ team_number: i, members: [] });
      }
      setTeams(initialTeams);
      return;
    }
    const teamData = roundData.teams.map((t) => {
      return {
        ...t,
        members: t?.members?.map((m) => {
          return { ...m, member_id: m.event_booking_member_id };
        }),
      } as any;
    });
    let teamN = 1;
    for (teamN; teamN <= maxTeams; teamN++) {
      if (teamData.some((td) => td.team_number === teamN)) {
        continue;
      }
      teamData.push({
        team_number: teamN,
        members: [],
      } as any);
    }
    teamData.sort((a, b) => a.team_number - b.team_number);

    setTeams(teamData);
  }, [bookingApplication, activeDateIds[0], maxTeams]);
  const {
    PopupComponent: MemeberSearchPopup,
    openPopup: openMemberSearchPopup,
    closePopup: closeMemberSearchPopup,
  } = usePopupPage("member-search");

  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [currentSelectedTeamNumber, setCurrentSelectedTeamNumber] = useState(0);

  const refetchBookings = useRefetchEventBookings();
  const alert = useAlert();
  const confirm = useConfirm();

  const handleAddTeams = (count: number) => {
    setMaxTeams((prev) => prev + count);
  };
  const handleSubmit = async (tempSave?: boolean) => {
    const notEmptyAddingTeams = teams?.filter((t) => {
      return t.members?.length && t.members?.length > 0;
    });
    if (!tempSave && (!activeDateIds[0] || !notEmptyAddingTeams?.length)) {
      alert("라운드 일자 및 팀 정보를 입력하세요");
      return;
    }

    notEmptyAddingTeams?.forEach((tm) => {
      tm.members.forEach((m: any) => {
        if (m.member_id && !m.event_booking_member_id) {
          m.event_booking_member_id = m.member_id;
        }
      });
    });

    try {
      setIsSubmitLoading(true);
      const teamSubmitRes = await createTeeshotAxiosInstance().post(
        `/evtBooking/booking/team${tempSave ? "?tempSave=1" : ""}`,
        {
          roundId: activeDateIds[0],
          teams: notEmptyAddingTeams,
        }
      );
      if (!teamSubmitRes.data.success) {
        throw new Error();
      }

      await refetchBookings();
      alert({
        title: tempSave ? "임시 저장" : `등록 완료! `,
        content: tempSave ? "조 편성이 임시저장 되었습니다." : `골프장에 전송되었습니다. `,
      });
      if (!tempSave) {
        // navigate("/year-booking/roundPayment");
      }
    } catch (e) {
      console.log("e :", e);
      setIsSubmitLoading(false);
      alert({
        content: "팀 등록 실패",
        onClose: () => {
          alert.resume();
        },
      });
      await alert.pause();
      window.location.reload();
    } finally {
      setIsSubmitLoading(false);
    }

    return;
  };
  if (!forcedRerenderFlag) {
    return <></>;
  }

  return (
    <>
      {isSubmitLoading && <SreenCoverLoading />}
      <Container className="flex-1 d-flex fd-c gap-1">
        <div className="content flex-1 d-flex fd-c gap-3">
          <div className="d-flex fd-c">
            <p>* 멤버 등록을 하신 후에</p>
            <p className="ml-2">조 편성을 7일 전까지 등록해 주세요~</p>
          </div>
          <DatePopupSelect
            label="부킹일자"
            boldLabel
            placeholder="부킹일자를 선택하세요."
            {...propsToInject}
            items={
              rounds?.map(
                (rd) =>
                  ({
                    id: rd.id,
                    name: dateFormat(new Date(rd.round_date || "")) ?? "",
                  } as any)
              ) ?? []
            }
          />
          <Divider />
          <div className="team-and-options d-flex fd-c">
            <Label content="조 편성" className="bold" />

            <div className="as-c italic">
              {currentRound?.is_fixed ? (
                <>
                  "<span className="fc-red fs-7">{currentRound?.teams?.length}</span>개 조 제출
                  되었습니다."
                </>
              ) : (
                <>
                  "<span className="fc-red fs-7">{currentRound?.teams?.length || 0}</span>개 조
                  임시저장 되었습니다."
                </>
              )}
            </div>
            <Button
              className={`mt-2`}
              $round
              $colorTheme="green"
              onClick={() => {
                openMemberSearchPopup();
              }}
            >
              조 편성하기
            </Button>
            {activeDateIds?.[0] ? (
              <>
                {" "}
                <>
                  <Divider />
                </>
              </>
            ) : (
              <>
                <div>라운드 일자를 선택하세요.</div>
              </>
            )}
          </div>
        </div>
        <DoubleButton
          nagativeMargin
          left={{
            name: "취소",
            size: "md",
            themeColor: "lightGray",
            onClick: () => navigate("/event-booking"),
          }}
          right={{
            name: "등록",
            size: "md",
            themeColor: "green",

            buttonCompProps: {
              disabled:
                !Boolean(currentRound?.teams?.length) ||
                !Boolean(activeDateIds?.length) ||
                Boolean(currentRound?.is_fixed),
            },
            onClick: () => {
              confirm({
                title: "라운드 정보 전송",
                content: (
                  <div className="d-flex fd-c gap-3">
                    <p>
                      조 편성과 라운드 옵션을 골프장에 전송하면 수정할 수 없으니 모두 완료되면
                      등록하시기 바랍니다.
                    </p>
                    <p>골프장에 등록하시겠습니까?</p>
                  </div>
                ),
                onConfirm: () => handleSubmit(),
              });
            },
          }}
        />
      </Container>
      {teams && (
        <MemeberSearchPopup
          type="back"
          headerMsg="조 편성"
          content={
            <>
              <MemberSearchPopupContentsEvent
                isFixed={Boolean(currentRound?.is_fixed)}
                handleSubmit={handleSubmit}
                teams={teams}
                closeMe={() => {
                  closeMemberSearchPopup();
                }}
                setTeams={setTeams}
                maxTeams={maxTeams}
                onAddTeams={handleAddTeams}
              />
            </>
          }
        />
      )}
    </>
  );
}

const Container = styled.div`
  height: 100%;
  .members-container {
    display: flex;
    gap: 10px;
    > .box {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid black;
      width: 50px;
    }
  }
  p.complete {
    display: flex;
    justify-content: center;
    font-weight: bold;
    font-size: 18px;
  }

  .team-and-options {
    display: flex;
    flex-direction: column;
    gap: 10px;
    position: relative;
    .cover {
      width: calc(100% + 30px);
      height: calc(100% + 10px);
      position: absolute;
      left: -15px;
      top: -5px;
      margin-right: -15px;

      background-color: #00000034;
    }
  }
`;

const TeamSelectorContainer = styled.div``;
